import { Download, Share, PlusSquare, MoreVertical, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import { usePwaInstall } from "@/lib/pwa";
import { useSeo } from "@/lib/draft";
import { PageHead } from "@/pages/ComoFunciona";
import { ShareBlock } from "@/components/ShareBlock";

const StepList = ({ title, steps, testid }) => (
  <div className="card" data-testid={testid}>
    <h2 className="text-xl font-extrabold">{title}</h2>
    <ol className="mt-4 space-y-4">
      {steps.map(([I, t], i) => (
        <li key={t} className="flex gap-3">
          <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[#EDF5FF] font-bold text-[#1465C8]">{i + 1}</span>
          <span className="flex items-center gap-2 pt-1.5">{I && <I size={18} className="text-[#1465C8]" />}{t}</span>
        </li>
      ))}
    </ol>
  </div>
);

export default function Instalar() {
  const { canPrompt, installed, prompt, ios } = usePwaInstall();
  useSeo("Instale a Conexão Litigium", "Instale a Conexão Litigium na tela inicial do seu celular Android ou iPhone, sem loja de aplicativos.");
  return (
    <>
      <PageHead eyebrow="Aplicativo" title="Instale a Conexão Litigium" text="Acesse com um toque, direto da tela inicial. Sem loja de aplicativos e com a mesma conta do site." />
      <section className="wrap mt-10">
        {installed ? (
          <p className="card flex items-center gap-3 font-semibold text-[#1465C8]" data-testid="pwa-installed-msg"><CheckCircle2 /> O aplicativo já está instalado neste dispositivo.</p>
        ) : canPrompt ? (
          <button className="btn-primary text-lg" data-testid="pwa-install-button" onClick={async () => (await prompt()) && toast.success("Aplicativo instalado")}>
            <Download /> Instalar aplicativo
          </button>
        ) : (
          <p className="rounded-2xl bg-[#EDF5FF] p-4 text-sm" data-testid="pwa-manual-hint">
            {ios ? "No iPhone, a instalação é feita pelo botão Compartilhar do Safari. Siga os passos abaixo." : "Se o botão de instalação não aparecer, siga as instruções do seu navegador abaixo."}
          </p>
        )}
      </section>
      <section className="wrap mt-8 grid gap-5 md:grid-cols-2">
        <StepList testid="install-android" title="Android (Chrome)" steps={[[null, "Abra a Conexão Litigium no Google Chrome"], [MoreVertical, "Toque no menu ⋮ no canto superior"], [Download, "Escolha “Instalar app” ou “Adicionar à tela inicial”"], [null, "Confirme. O ícone aparecerá na tela inicial"]]} />
        <StepList testid="install-ios" title="iPhone (Safari)" steps={[[null, "Abra a Conexão Litigium no Safari"], [Share, "Toque no botão Compartilhar"], [PlusSquare, "Escolha “Adicionar à Tela de Início”"], [null, "Toque em “Adicionar”. Pronto!"]]} />
      </section>
      <section className="wrap mt-10">
        <h2 className="mb-4 text-xl font-extrabold">Envie o link para alguém</h2>
        <ShareBlock path="/instalar" testid="install-share" />
      </section>
    </>
  );
}
